import { Icon } from "icons";
import { observer } from "mobx-react-lite";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { cn, Button } from "ui";

import { useUnlinkWorkoutItem } from "src/workouts/useUnlinkWorkoutItem";
import { useWorkoutEditStore } from "src/workouts/WorkoutEditContext";

interface MinimapUnlinkZoneProps {
  itemId: string;
  previousItemId: string;
  level: number;
}

export const MinimapUnlinkZone = observer(function MinimapUnlinkZone(
  props: MinimapUnlinkZoneProps,
) {
  const { t } = useTranslation();
  const workoutEditStore = useWorkoutEditStore();
  const { unlink, isLoading } = useUnlinkWorkoutItem();
  const [isHovered, setIsHovered] = useState(false);

  const isInsideSuperset = workoutEditStore.isInsideSuperset(props.itemId);

  if (!isInsideSuperset) {
    return null;
  }

  function handleUnlink() {
    const previousItem = workoutEditStore.getWorkoutItemById(
      props.previousItemId,
    );
    const isFirstChild = previousItem.order === 0;
    unlink(isFirstChild ? props.previousItemId : props.itemId);
  }

  return (
    <div
      className={cn(
        "absolute -top-[4px] left-0 right-0 h-2 -translate-y-1/2 flex items-center justify-center z-10",
        "transition-opacity duration-150",
      )}
      style={{ paddingLeft: `${props.level * 12}px` }}
      onMouseEnter={() => {
        setIsHovered(true);
      }}
      onMouseLeave={() => {
        setIsHovered(false);
      }}
    >
      <Button
        variant="ghost"
        size="icon"
        disabled={isLoading}
        onClick={handleUnlink}
        className={cn(
          "h-3.5 w-3.5 rounded-full z-10 transition-all",
          "bg-red-400 hover:bg-red-500",
          "text-white hover:text-white",
          isHovered ? "opacity-100 scale-100" : "opacity-0 scale-75",
        )}
        title={t("editWorkout.unlink.tooltip")}
      >
        <Icon
          name="tabler-unlink"
          className="!h-2.5 !w-2.5"
          strokeWidth={2.5}
        />
      </Button>
    </div>
  );
});
